module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sbs"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "sbs-loading"
  }, [_c('div', {
    staticClass: "sbs-spinner"
  })]) : (_vm.loadError) ? _c('div', {
    staticClass: "sbs-error"
  }, [_c('p', {
    staticClass: "sbs-error-title"
  }, [_vm._v("Could not load billing")]), _vm._v(" "), _c('p', {
    staticClass: "sbs-error-msg"
  }, [_vm._v(_vm._s(_vm.loadError))]), _vm._v(" "), _c('button', {
    staticClass: "sbs-btn sbs-btn-outline",
    on: {
      "click": _vm.fetchAll
    }
  }, [_vm._v("Retry")])]) : _c('div', {
    staticClass: "sbs-inner"
  }, [_c('header', {
    staticClass: "sbs-header"
  }, [_c('h1', {
    staticClass: "sbs-title"
  }, [_vm._v("Subscription & Billing")]), _vm._v(" "), _c('p', {
    staticClass: "sbs-subtitle"
  }, [_vm._v(_vm._s(_vm.billingPageSubtitle))])]), _vm._v(" "), _c('nav', {
    staticClass: "sbs-tabs",
    attrs: {
      "role": "tablist"
    }
  }, [_c('button', {
    class: ['sbs-tab', {
      active: _vm.activeTab === 'plans'
    }],
    attrs: {
      "type": "button",
      "role": "tab",
      "aria-selected": _vm.activeTab === 'plans'
    },
    on: {
      "click": function($event) {
        _vm.activeTab = 'plans'
      }
    }
  }, [_vm._v("Pricing & Plans")]), _vm._v(" "), (_vm.showUsageTab) ? _c('button', {
    class: ['sbs-tab', {
      active: _vm.activeTab === 'usage'
    }],
    attrs: {
      "type": "button",
      "role": "tab",
      "aria-selected": _vm.activeTab === 'usage'
    },
    on: {
      "click": function($event) {
        _vm.activeTab = 'usage'
      }
    }
  }, [_vm._v("Usage")]) : _vm._e(), _vm._v(" "), _c('button', {
    class: ['sbs-tab', {
      active: _vm.activeTab === 'history'
    }],
    attrs: {
      "type": "button",
      "role": "tab",
      "aria-selected": _vm.activeTab === 'history'
    },
    on: {
      "click": function($event) {
        _vm.activeTab = 'history'
      }
    }
  }, [_vm._v("Billing History")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab === 'plans'),
      expression: "activeTab === 'plans'"
    }],
    staticClass: "sbs-panel"
  }, [(_vm.billingVariant === 'new') ? [(_vm.isPaymentPastDue) ? _c('div', {
    staticClass: "sbs-trial-block sbs-trial-block-expired"
  }, [_c('div', {
    staticClass: "sbs-trial-hd"
  }, [_c('div', {
    staticClass: "sbs-trial-hd-left"
  }, [_c('div', {
    staticClass: "sbs-trial-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('svg', {
    attrs: {
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2.5",
      "viewBox": "0 0 24 24"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "10"
    }
  }), _c('line', {
    attrs: {
      "x1": "12",
      "y1": "8",
      "x2": "12",
      "y2": "12"
    }
  }), _c('line', {
    attrs: {
      "x1": "12",
      "y1": "16",
      "x2": "12.01",
      "y2": "16"
    }
  })])]), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('div', {
    staticClass: "sbs-trial-footnote"
  }, [_c('svg', {
    attrs: {
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "viewBox": "0 0 24 24",
      "aria-hidden": "true"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "10"
    }
  }), _c('line', {
    attrs: {
      "x1": "12",
      "y1": "16",
      "x2": "12",
      "y2": "12"
    }
  }), _c('line', {
    attrs: {
      "x1": "12",
      "y1": "8",
      "x2": "12.01",
      "y2": "8"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("Update your payment method below to restore billing and keep your alerts running. Your plan and data are unchanged.")])]), _vm._v(" "), (_vm.canManageBilling) ? _c('button', {
    staticClass: "sbs-btn sbs-btn-upgrade sbs-past-due-cta",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.scrollToPaymentMethod
    }
  }, [_vm._v("Update payment method →")]) : _c('p', {
    staticClass: "sbs-member-admin-hint"
  }, [_vm._v("Ask your account admin to update the payment method on file.")])]) : (_vm.isTrialBillingExpired) ? _c('div', {
    staticClass: "sbs-trial-block sbs-trial-block-expired"
  }, [_c('div', {
    staticClass: "sbs-trial-hd"
  }, [_c('div', {
    staticClass: "sbs-trial-hd-left"
  }, [_c('div', {
    staticClass: "sbs-trial-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('svg', {
    attrs: {
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2.5",
      "viewBox": "0 0 24 24"
    }
  }, [_c('rect', {
    attrs: {
      "x": "3",
      "y": "11",
      "width": "18",
      "height": "11",
      "rx": "2"
    }
  }), _c('path', {
    attrs: {
      "d": "M7 11V7a5 5 0 0110 0v4"
    }
  })])]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('div', {
    staticClass: "sbs-trial-progress-wrap"
  }, [_c('div', {
    staticClass: "sbs-trial-progress-meta"
  }, [_c('span', [_vm._v("Trial completed")]), _vm._v(" "), _c('span', [_vm._v("Ended " + _vm._s(_vm.nextBillingDateDisplay))])]), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('div', {
    staticClass: "sbs-trial-stats"
  }, [_c('div', {
    staticClass: "sbs-trial-stat"
  }, [_c('div', {
    staticClass: "sbs-trial-stat-lbl"
  }, [_vm._v("ASINs monitored")]), _vm._v(" "), _c('div', {
    staticClass: "sbs-trial-stat-val"
  }, [_vm._v(_vm._s(_vm.summaryAsinsDisplay))]), _vm._v(" "), _c('div', {
    staticClass: "sbs-trial-stat-sub"
  }, [_vm._v("During your trial")])]), _vm._v(" "), _c('div', {
    staticClass: "sbs-trial-stat"
  }, [_c('div', {
    staticClass: "sbs-trial-stat-lbl"
  }, [_vm._v("Changes caught")]), _vm._v(" "), _c('div', {
    staticClass: "sbs-trial-stat-val"
  }, [_vm._v(_vm._s(_vm.orderVolumeChangesCaughtDisplay))]), _vm._v(" "), _c('div', {
    staticClass: "sbs-trial-stat-sub"
  }, [_vm._v("In the last 7 days")])]), _vm._v(" "), _c('div', {
    staticClass: "sbs-trial-stat"
  }, [_c('div', {
    staticClass: "sbs-trial-stat-lbl"
  }, [_vm._v(_vm._s(_vm.trialPlanChosen ? 'Your plan' : 'Recommended plan'))]), _vm._v(" "), _c('div', {
    staticClass: "sbs-trial-stat-val"
  }, [_vm._v(_vm._s(_vm.trialPlanChosen ? _vm.planAfterTrialLabel : 'Pro'))]), _vm._v(" "), _c('div', {
    staticClass: "sbs-trial-stat-sub"
  }, [_vm._v(_vm._s(_vm.canManageBilling ? (_vm.trialPlanChosen ? 'Add a payment method to resume' : 'Pick a plan below to resume') : 'Ask your admin to choose a plan'))])])]), _vm._v(" "), _c('div', {
    staticClass: "sbs-trial-footnote"
  }, [_c('svg', {
    attrs: {
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "viewBox": "0 0 24 24",
      "aria-hidden": "true"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "10"
    }
  }), _c('line', {
    attrs: {
      "x1": "12",
      "y1": "16",
      "x2": "12",
      "y2": "12"
    }
  }), _c('line', {
    attrs: {
      "x1": "12",
      "y1": "8",
      "x2": "12.01",
      "y2": "8"
    }
  })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.canManageBilling ? 'Your alerts are paused. Pick a plan below to resume tracking — your data is safe.' : 'Your alerts are paused. Ask your account admin to choose a plan — your data is safe.'))])])]) : (_vm.isTrialBillingActive) ? _c('div', {
    staticClass: "sbs-trial-block"
  }, [_c('div', {
    staticClass: "sbs-trial-hd"
  }, [_c('div', {
    staticClass: "sbs-trial-hd-left"
  }, [_c('div', {
    staticClass: "sbs-trial-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('svg', {
    attrs: {
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2.5",
      "viewBox": "0 0 24 24"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "10"
    }
  }), _c('polyline', {
    attrs: {
      "points": "12 6 12 12 16 14"
    }
  })])]), _vm._v(" "), _c('div', [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "sbs-trial-title"
  }, [_vm._v("You're on a free " + _vm._s(_vm.trialLengthDays) + "-day trial")])])]), _vm._v(" "), _c('div', {
    staticClass: "sbs-trial-days"
  }, [_c('div', {
    staticClass: "sbs-trial-days-num"
  }, [_vm._v(_vm._s(_vm.trialDaysRemainingDisplay))]), _vm._v(" "), _c('div', {
    staticClass: "sbs-trial-days-lbl"
  }, [_vm._v("Days remaining")])])]), _vm._v(" "), _c('div', {
    staticClass: "sbs-trial-progress-wrap"
  }, [_c('div', {
    staticClass: "sbs-trial-progress-meta"
  }, [_c('span', [_vm._v(_vm._s(_vm.trialDayOfDisplay))]), _vm._v(" "), _c('span', [_vm._v("Trial ends " + _vm._s(_vm.nextBillingDateDisplay))])]), _vm._v(" "), _c('div', {
    staticClass: "sbs-trial-progress"
  }, [_c('div', {
    staticClass: "sbs-trial-progress-fill",
    style: ({
      width: _vm.trialProgressWidth
    })
  })])]), _vm._v(" "), _c('div', {
    staticClass: "sbs-trial-stats"
  }, [_c('div', {
    staticClass: "sbs-trial-stat"
  }, [_c('div', {
    staticClass: "sbs-trial-stat-lbl"
  }, [_vm._v("ASINs monitored")]), _vm._v(" "), _c('div', {
    staticClass: "sbs-trial-stat-val"
  }, [_vm._v(_vm._s(_vm.summaryAsinsDisplay))])]), _vm._v(" "), _c('div', {
    staticClass: "sbs-trial-stat"
  }, [_c('div', {
    staticClass: "sbs-trial-stat-lbl"
  }, [_vm._v("Changes caught")]), _vm._v(" "), _c('div', {
    staticClass: "sbs-trial-stat-val"
  }, [_vm._v(_vm._s(_vm.orderVolumeChangesCaughtDisplay))]), _vm._v(" "), _c('div', {
    staticClass: "sbs-trial-stat-sub"
  }, [_vm._v("In the last 7 days")])]), _vm._v(" "), _c('div', {
    staticClass: "sbs-trial-stat"
  }, [_c('div', {
    staticClass: "sbs-trial-stat-lbl"
  }, [_vm._v("Plan after trial")]), _vm._v(" "), _c('div', {
    staticClass: "sbs-trial-stat-val"
  }, [_vm._v(_vm._s(_vm.planAfterTrialLabel))]), _vm._v(" "), _c('div', {
    staticClass: "sbs-trial-stat-sub"
  }, [_vm._v(_vm._s(_vm.planAfterTrialSub))])])]), _vm._v(" "), _c('div', {
    staticClass: "sbs-trial-footnote"
  }, [_c('svg', {
    attrs: {
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "viewBox": "0 0 24 24",
      "aria-hidden": "true"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "10"
    }
  }), _c('line', {
    attrs: {
      "x1": "12",
      "y1": "16",
      "x2": "12",
      "y2": "12"
    }
  }), _c('line', {
    attrs: {
      "x1": "12",
      "y1": "8",
      "x2": "12.01",
      "y2": "8"
    }
  })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.canManageBilling ? 'Track as many orders as you need during your trial. Pick a plan below — you can change it any time before your trial ends.' : 'Track as many orders as you need during your trial. Your admin manages plan selection for this account.'))])])]) : _c('div', {
    staticClass: "sbs-current-plan"
  }, [_c('div', {
    staticClass: "sbs-current-icon"
  }, [_c('svg', {
    attrs: {
      "width": "22",
      "height": "22",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M13 2L3 14h8l-1 8 10-12h-8l1-8z",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linejoin": "round"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "sbs-current-main"
  }, [_c('span', {
    staticClass: "sbs-current-name"
  }, [_vm._v(_vm._s(_vm.currentPlanTitle))]), _vm._v(" "), _c('span', {
    staticClass: "sbs-current-meta"
  }, [_vm._v(_vm._s(_vm.currentPlanSubtitle))])]), _vm._v(" "), _c('div', {
    staticClass: "sbs-current-next"
  }, [_c('span', {
    staticClass: "sbs-current-next-label"
  }, [_vm._v("Next billing")]), _vm._v(" "), _c('span', {
    staticClass: "sbs-current-next-date"
  }, [_vm._v(_vm._s(_vm.nextBillingDateDisplay))])])]), _vm._v(" "), (_vm.canManageBilling && !_vm.isFlatYearlyPlan) ? [_c('h2', {
    staticClass: "sbs-section-heading"
  }, [_vm._v(_vm._s(_vm.planSectionHeading))]), _vm._v(" "), _c('p', {
    staticClass: "sbs-plans-help"
  }, [_vm._v(_vm._s(_vm.planSectionHelp))]), _vm._v(" "), _c('div', {
    class: ['sbs-plan-cards', {
      'sbs-plan-cards-3': _vm.showProAnnualCard
    }]
  }, [_c('div', {
    class: _vm.planCardClasses('starter')
  }, [(_vm.planCard('starter').ribbon) ? _c('span', {
    class: ['sbs-plan-ribbon', 'sbs-plan-ribbon-' + _vm.planCard('starter').ribbonTone]
  }, [_vm._v(_vm._s(_vm.planCard('starter').ribbon))]) : _vm._e(), _vm._v(" "), _c('h3', {
    staticClass: "sbs-plan-name"
  }, [_vm._v("Starter")]), _vm._v(" "), _c('p', {
    staticClass: "sbs-plan-for"
  }, [_vm._v("For brands on 1–2 storefronts")]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('p', {
    staticClass: "sbs-plan-incl"
  }, [_vm._v("2 storefronts included")]), _vm._v(" "), _c('button', {
    class: _vm.planButtonClasses('starter'),
    attrs: {
      "type": "button",
      "disabled": _vm.planCard('starter').disabled,
      "title": _vm.planCard('starter').title
    },
    on: {
      "click": function($event) {
        return _vm.onPlanAction('starter')
      }
    }
  }, [_vm._v(_vm._s(_vm.planCard('starter').label))]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "sbs-plan-footnote"
  }, [_vm._v("Need more storefronts? Pro scales with you.")])]), _vm._v(" "), _c('div', {
    class: _vm.planCardClasses('pro')
  }, [(_vm.planCard('pro').ribbon) ? _c('span', {
    class: ['sbs-plan-ribbon', 'sbs-plan-ribbon-' + _vm.planCard('pro').ribbonTone]
  }, [_vm._v(_vm._s(_vm.planCard('pro').ribbon))]) : _vm._e(), _vm._v(" "), _c('h3', {
    staticClass: "sbs-plan-name"
  }, [_vm._v("Pro")]), _vm._v(" "), _c('p', {
    staticClass: "sbs-plan-for"
  }, [_vm._v("Scales with your storefronts")]), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('p', {
    staticClass: "sbs-plan-incl"
  }, [_vm._v("5 storefronts included")]), _vm._v(" "), _c('button', {
    class: _vm.planButtonClasses('pro'),
    attrs: {
      "type": "button",
      "disabled": _vm.planCard('pro').disabled,
      "title": _vm.planCard('pro').title
    },
    on: {
      "click": function($event) {
        return _vm.onPlanAction('pro')
      }
    }
  }, [_vm._v(_vm._s(_vm.planCard('pro').label))]), _vm._v(" "), _c('p', {
    staticClass: "sbs-plan-plus-label"
  }, [_vm._v("EVERYTHING IN STARTER, PLUS")]), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "sbs-sf-counter"
  }, [_c('div', {
    staticClass: "sbs-sf-counter-q"
  }, [_vm._v("How many storefronts do you manage?")]), _vm._v(" "), _c('div', {
    staticClass: "sbs-sf-counter-row"
  }, [_c('button', {
    staticClass: "sbs-sf-step",
    attrs: {
      "type": "button",
      "aria-label": "Fewer storefronts",
      "disabled": _vm.proStorefrontCount <= 1
    },
    on: {
      "click": function($event) {
        _vm.proStorefrontCount = Math.max(1, _vm.proStorefrontCount - 1)
      }
    }
  }, [_vm._v("−")]), _vm._v(" "), _c('span', {
    staticClass: "sbs-sf-count"
  }, [_vm._v(_vm._s(_vm.proStorefrontCount))]), _vm._v(" "), _c('button', {
    staticClass: "sbs-sf-step",
    attrs: {
      "type": "button",
      "aria-label": "More storefronts",
      "disabled": _vm.proStorefrontCount >= 120
    },
    on: {
      "click": function($event) {
        _vm.proStorefrontCount = Math.min(120, _vm.proStorefrontCount + 1)
      }
    }
  }, [_vm._v("+")])]), _vm._v(" "), _c('div', {
    staticClass: "sbs-sf-hint"
  }, [_vm._v(_vm._s(_vm.proStorefrontHint))]), _vm._v(" "), _c('div', {
    staticClass: "sbs-sf-total-box"
  }, [_c('span', {
    staticClass: "sbs-sf-total-label"
  }, [_vm._v("Your Pro plan")]), _vm._v(" "), _c('span', {
    staticClass: "sbs-sf-total-price"
  }, [_vm._v("$" + _vm._s(_vm.proStorefrontTotalPrice)), _c('span', {
    staticClass: "sbs-sf-total-period"
  }, [_vm._v(" /month")])])]), _vm._v(" "), _c('div', {
    staticClass: "sbs-sf-save"
  }, [_vm._v("↓ Every storefront you add costs less than the last")]), _vm._v(" "), _c('button', {
    staticClass: "sbs-sf-vol-toggle",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showVolumePricing = !_vm.showVolumePricing
      }
    }
  }, [_vm._v("\n                View volume pricing " + _vm._s(_vm.showVolumePricing ? '▴' : '▾') + "\n              ")]), _vm._v(" "), (_vm.showVolumePricing) ? _c('table', {
    staticClass: "sbs-sf-vol-table"
  }, [_vm._m(9), _vm._v(" "), _vm._m(10)]) : _vm._e()])]), _vm._v(" "), (_vm.showProAnnualCard) ? _c('div', {
    class: _vm.planCardClasses('pro_annual')
  }, [(_vm.planCard('pro_annual').ribbon) ? _c('span', {
    class: ['sbs-plan-ribbon', 'sbs-plan-ribbon-' + _vm.planCard('pro_annual').ribbonTone]
  }, [_vm._v(_vm._s(_vm.planCard('pro_annual').ribbon))]) : _vm._e(), _vm._v(" "), _c('h3', {
    staticClass: "sbs-plan-name"
  }, [_vm._v("Pro Annual")]), _vm._v(" "), _c('p', {
    staticClass: "sbs-plan-for"
  }, [_vm._v("Pro, paid once a year")]), _vm._v(" "), _c('p', {
    staticClass: "sbs-plan-price"
  }, [_c('span', {
    staticClass: "sbs-plan-currency"
  }, [_vm._v("$")]), _c('span', {
    staticClass: "sbs-plan-amount"
  }, [_vm._v(_vm._s(_vm.proAnnualPriceDisplay))]), _c('span', {
    staticClass: "sbs-plan-period"
  }, [_vm._v("/year")])]), _vm._v(" "), _c('p', {
    staticClass: "sbs-plan-incl"
  }, [_vm._v("5 storefronts included · one invoice a year")]), _vm._v(" "), _c('button', {
    class: _vm.planButtonClasses('pro_annual'),
    attrs: {
      "type": "button",
      "disabled": _vm.planCard('pro_annual').disabled,
      "title": _vm.planCard('pro_annual').title
    },
    on: {
      "click": function($event) {
        return _vm.onPlanAction('pro_annual')
      }
    }
  }, [_vm._v(_vm._s(_vm.planCard('pro_annual').label))]), _vm._v(" "), _c('p', {
    staticClass: "sbs-plan-plus-label"
  }, [_vm._v("EVERYTHING IN PRO, PLUS")]), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "sbs-plan-footnote"
  }, [_vm._v(_vm._s(_vm.proAnnualFootnote))])]) : _vm._e()])] : _c('p', {
    staticClass: "sbs-member-admin-hint"
  }, [_vm._v("Plan changes are managed by your account admin.")]), _vm._v(" "), (!_vm.canManageBilling) ? _c('div', {
    staticClass: "sbs-your-plan-stats sbs-member-billing-stats"
  }, [_c('div', {
    staticClass: "sbs-your-plan-stat"
  }, [_c('span', {
    staticClass: "sbs-your-plan-stat-label"
  }, [_vm._v("Last billed")]), _vm._v(" "), _c('span', {
    staticClass: "sbs-your-plan-stat-value"
  }, [_vm._v("$" + _vm._s(_vm.summaryLastBilledAmount))]), _vm._v(" "), _c('span', {
    staticClass: "sbs-your-plan-stat-sub"
  }, [_vm._v(_vm._s(_vm.summaryLastBilledDetail))])]), _vm._v(" "), _c('div', {
    staticClass: "sbs-your-plan-stat"
  }, [_c('span', {
    staticClass: "sbs-your-plan-stat-label"
  }, [_vm._v("Orders this month")]), _vm._v(" "), _c('span', {
    staticClass: "sbs-your-plan-stat-value"
  }, [_vm._v(_vm._s(_vm.orderVolumeOrdersThisMonthDisplay))]), _vm._v(" "), _c('span', {
    staticClass: "sbs-your-plan-stat-sub"
  }, [_vm._v(_vm._s(_vm.orderVolumeOrdersCompareLine))])])]) : _vm._e()] : (_vm.billingVariant === 'legacy') ? [_c('div', {
    staticClass: "sbs-your-plan-card"
  }, [_c('span', {
    staticClass: "sbs-your-plan-badge"
  }, [_vm._v("Your plan")]), _vm._v(" "), _c('div', {
    staticClass: "sbs-your-plan-head"
  }, [_c('div', {
    staticClass: "sbs-your-plan-head-main"
  }, [_c('h2', {
    staticClass: "sbs-your-plan-title"
  }, [_vm._v(_vm._s(_vm.legacyPlanTitle))]), _vm._v(" "), _c('p', {
    staticClass: "sbs-your-plan-desc"
  }, [_vm._v(_vm._s(_vm.legacyPricingLine))])]), _vm._v(" "), _c('div', {
    staticClass: "sbs-your-plan-next"
  }, [_c('span', {
    staticClass: "sbs-your-plan-next-label"
  }, [_vm._v("Next billing")]), _vm._v(" "), _c('span', {
    staticClass: "sbs-your-plan-next-date"
  }, [_vm._v(_vm._s(_vm.nextBillingDateDisplay))])])]), _vm._v(" "), _c('div', {
    staticClass: "sbs-your-plan-stats"
  }, [_c('div', {
    staticClass: "sbs-your-plan-stat"
  }, [_c('span', {
    staticClass: "sbs-your-plan-stat-label"
  }, [_vm._v("Last billed")]), _vm._v(" "), _c('span', {
    staticClass: "sbs-your-plan-stat-value"
  }, [_vm._v("$" + _vm._s(_vm.summaryLastBilledAmount))]), _vm._v(" "), _c('span', {
    staticClass: "sbs-your-plan-stat-sub"
  }, [_vm._v(_vm._s(_vm.summaryLastBilledDetail))])]), _vm._v(" "), _c('div', {
    staticClass: "sbs-your-plan-stat"
  }, [_c('span', {
    staticClass: "sbs-your-plan-stat-label"
  }, [_vm._v("ASINs tracked")]), _vm._v(" "), _c('span', {
    staticClass: "sbs-your-plan-stat-value"
  }, [_vm._v(_vm._s(_vm.summaryAsinsDisplay))]), _vm._v(" "), _c('span', {
    staticClass: "sbs-your-plan-stat-sub"
  }, [_vm._v("Across all marketplaces")])])]), _vm._v(" "), _c('p', {
    staticClass: "sbs-your-plan-foot"
  }, [_vm._v(_vm._s(_vm.legacyFootnote))])]), _vm._v(" "), (_vm.canManageBilling) ? _c('button', {
    staticClass: "sbs-email-cta",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.openPlanChangeModal
    }
  }, [_c('svg', {
    attrs: {
      "width": "18",
      "height": "18",
      "viewBox": "0 0 20 20",
      "fill": "currentColor",
      "aria-hidden": "true"
    }
  }, [_c('path', {
    attrs: {
      "d": "M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a1.99 1.99 0 00-1.997 1.884z"
    }
  }), _c('path', {
    attrs: {
      "d": "M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z"
    }
  })]), _vm._v("\n          Looking to change plans? Email us →\n        ")]) : _vm._e()] : [(_vm.isDailyUsageTrialExpiredNoPayment) ? _c('div', {
    staticClass: "sbs-trial-block sbs-trial-block-expired sbs-daily-trial-expired"
  }, [_c('div', {
    staticClass: "sbs-trial-hd"
  }, [_c('div', {
    staticClass: "sbs-trial-hd-left"
  }, [_c('div', {
    staticClass: "sbs-trial-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('svg', {
    attrs: {
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2.5",
      "viewBox": "0 0 24 24"
    }
  }, [_c('rect', {
    attrs: {
      "x": "3",
      "y": "11",
      "width": "18",
      "height": "11",
      "rx": "2"
    }
  }), _c('path', {
    attrs: {
      "d": "M7 11V7a5 5 0 0110 0v4"
    }
  })])]), _vm._v(" "), _vm._m(12)]), _vm._v(" "), _vm._m(13)]), _vm._v(" "), _c('div', {
    staticClass: "sbs-trial-progress-wrap"
  }, [_c('div', {
    staticClass: "sbs-trial-progress-meta"
  }, [_c('span', [_vm._v("Trial completed")]), _vm._v(" "), _c('span', [_vm._v("Ended " + _vm._s(_vm.nextBillingDateDisplay))])]), _vm._v(" "), _vm._m(14)]), _vm._v(" "), _c('div', {
    staticClass: "sbs-trial-footnote"
  }, [_c('svg', {
    attrs: {
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "viewBox": "0 0 24 24",
      "aria-hidden": "true"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "10"
    }
  }), _c('line', {
    attrs: {
      "x1": "12",
      "y1": "16",
      "x2": "12",
      "y2": "12"
    }
  }), _c('line', {
    attrs: {
      "x1": "12",
      "y1": "8",
      "x2": "12.01",
      "y2": "8"
    }
  })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.canManageBilling ? 'Add a payment method below to resume daily usage billing and keep your alerts running. Your tracked ASINs and data are unchanged.' : 'Your trial has ended and no payment method is on file. Ask your account admin to add a payment method to resume billing.'))])]), _vm._v(" "), (_vm.canManageBilling) ? _c('button', {
    staticClass: "sbs-btn sbs-btn-upgrade sbs-past-due-cta",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.scrollToPaymentMethod
    }
  }, [_vm._v("Add payment method →")]) : _c('p', {
    staticClass: "sbs-member-admin-hint"
  }, [_vm._v("Ask your account admin to add a payment method on file.")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "sbs-your-plan-card sbs-your-plan-daily"
  }, [_c('span', {
    staticClass: "sbs-your-plan-badge"
  }, [_vm._v("Your plan")]), _vm._v(" "), _c('div', {
    staticClass: "sbs-your-plan-head"
  }, [_c('div', {
    staticClass: "sbs-your-plan-head-main"
  }, [_c('h2', {
    staticClass: "sbs-your-plan-title"
  }, [_vm._v(_vm._s(_vm.dailyPlanTitle))]), _vm._v(" "), _c('p', {
    staticClass: "sbs-your-plan-desc"
  }, [_vm._v(_vm._s(_vm.dailyPlanSubtitle))])]), _vm._v(" "), _c('div', {
    staticClass: "sbs-your-plan-next"
  }, [_c('span', {
    staticClass: "sbs-your-plan-next-label"
  }, [_vm._v("Next billing")]), _vm._v(" "), _c('span', {
    staticClass: "sbs-your-plan-next-date"
  }, [_vm._v(_vm._s(_vm.nextBillingDateDisplay))])])]), _vm._v(" "), _c('div', {
    staticClass: "sbs-your-plan-stats"
  }, [_c('div', {
    staticClass: "sbs-your-plan-stat"
  }, [_c('span', {
    staticClass: "sbs-your-plan-stat-label"
  }, [_vm._v("Last billed")]), _vm._v(" "), _c('span', {
    staticClass: "sbs-your-plan-stat-value"
  }, [_vm._v("$" + _vm._s(_vm.summaryLastBilledAmount))]), _vm._v(" "), _c('span', {
    staticClass: "sbs-your-plan-stat-sub"
  }, [_vm._v(_vm._s(_vm.summaryLastBilledDetail))])]), _vm._v(" "), _c('div', {
    staticClass: "sbs-your-plan-stat"
  }, [_c('span', {
    staticClass: "sbs-your-plan-stat-label"
  }, [_vm._v("Projected this month")]), _vm._v(" "), _c('span', {
    staticClass: "sbs-your-plan-stat-value"
  }, [_vm._v(_vm._s(_vm.projectedMonthUsesEstimate ? '~' : '') + "$" + _vm._s(_vm.projectedMonthAmount))]), _vm._v(" "), _c('span', {
    staticClass: "sbs-your-plan-stat-sub"
  }, [_vm._v(_vm._s(_vm.projectedMonthSubtext))])])]), _vm._v(" "), _c('div', {
    staticClass: "sbs-asin-meter"
  }, [_c('span', {
    staticClass: "sbs-asin-meter-label"
  }, [_vm._v("ASINs currently tracked")]), _vm._v(" "), _c('span', {
    staticClass: "sbs-asin-meter-value"
  }, [_vm._v(_vm._s(_vm.summaryAsinsDisplay) + " ASINs")])]), _vm._v(" "), _c('p', {
    staticClass: "sbs-your-plan-foot"
  }, [_vm._v(_vm._s(_vm.dailyFootnote))])]), _vm._v(" "), (_vm.canManageBilling) ? _c('button', {
    staticClass: "sbs-email-cta",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.openPlanChangeModal
    }
  }, [_c('svg', {
    attrs: {
      "width": "18",
      "height": "18",
      "viewBox": "0 0 20 20",
      "fill": "currentColor",
      "aria-hidden": "true"
    }
  }, [_c('path', {
    attrs: {
      "d": "M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a1.99 1.99 0 00-1.997 1.884z"
    }
  }), _c('path', {
    attrs: {
      "d": "M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z"
    }
  })]), _vm._v("\n          Looking to change plans? Email us →\n        ")]) : _vm._e()], _vm._v(" "), _vm._m(15), _vm._v(" "), (_vm.canManageBilling && (_vm.$root.paymentStatus !== 0 || _vm.billingVariant === 'new' || _vm.isDailyUsageTrialExpiredNoPayment)) ? _c('div', {
    staticClass: "sbs-payment-method-section",
    attrs: {
      "id": "payment-method"
    }
  }, [_c('h2', {
    staticClass: "sbs-section-heading"
  }, [_vm._v("Payment Method")]), _vm._v(" "), _c('p', {
    staticClass: "sbs-payment-method-sub"
  }, [_vm._v("Used for all SentryKit subscription charges")]), _vm._v(" "), (_vm.savedPaymentMethods.length) ? _c('div', {
    staticClass: "sbs-pm-list"
  }, _vm._l((_vm.savedPaymentMethods), function(pm, idx) {
    return _c('div', {
      key: pm.id || idx,
      class: ['sbs-pm-display', {
        'sbs-pm-ach': pm.kind === 'ach'
      }]
    }, [_c('span', {
      staticClass: "sbs-pm-brand",
      class: {
        'sbs-pm-bank': pm.kind === 'ach'
      },
      attrs: {
        "aria-hidden": "true"
      }
    }, [_vm._v(_vm._s(pm.brandShort))]), _vm._v(" "), _c('div', {
      staticClass: "sbs-pm-display-main"
    }, [_c('div', {
      staticClass: "sbs-pm-display-top"
    }, [_c('span', {
      staticClass: "sbs-pm-display-title"
    }, [_vm._v(_vm._s(pm.label))]), _vm._v(" "), _c('div', {
      staticClass: "sbs-pm-display-actions"
    }, [(pm.isDefault) ? _c('span', {
      staticClass: "sbs-pm-default-badge"
    }, [_vm._v("Default")]) : _vm._e(), _vm._v(" "), (!pm.isDefault && pm.id && _vm.savedPaymentMethods.length > 1) ? _c('button', {
      staticClass: "sbs-pm-set-default-link",
      attrs: {
        "type": "button",
        "disabled": _vm.setDefaultInProgress || _vm.detachInProgress
      },
      on: {
        "click": function($event) {
          return _vm.setPaymentMethodAsDefault(pm.id)
        }
      }
    }, [_vm._v("Set as default")]) : _vm._e(), _vm._v(" "), (pm.id) ? _c('button', {
      staticClass: "sbs-pm-remove-link",
      attrs: {
        "type": "button",
        "disabled": _vm.detachInProgress
      },
      on: {
        "click": function($event) {
          return _vm.removePaymentMethod(pm)
        }
      }
    }, [_vm._v("Remove")]) : _vm._e()])]), _vm._v(" "), _c('span', {
      staticClass: "sbs-pm-display-meta"
    }, [_vm._v(_vm._s(pm.metaLine))])])])
  }), 0) : (_vm.displayCardInfo) ? _c('div', {
    staticClass: "sbs-pm-display"
  }, [_c('span', {
    staticClass: "sbs-pm-brand",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v(_vm._s(_vm.displayCardInfo.brandShort))]), _vm._v(" "), _c('div', {
    staticClass: "sbs-pm-display-main"
  }, [_c('div', {
    staticClass: "sbs-pm-display-top"
  }, [_c('span', {
    staticClass: "sbs-pm-display-title"
  }, [_vm._v(_vm._s(_vm.displayCardInfo.label))]), _vm._v(" "), _vm._m(16)]), _vm._v(" "), _c('span', {
    staticClass: "sbs-pm-display-meta"
  }, [_vm._v(_vm._s(_vm.displayCardInfo.metaLine))])])]) : (_vm.paymentMethod && _vm.paymentMethod.method === 'ach') ? _c('div', {
    staticClass: "sbs-pm-display sbs-pm-ach"
  }, [_c('span', {
    staticClass: "sbs-pm-brand sbs-pm-bank"
  }, [_vm._v("ACH")]), _vm._v(" "), _vm._m(17)]) : _c('div', {
    staticClass: "sbs-pm-empty"
  }, [_c('p', [_vm._v("No card or bank account on file yet.")])]), _vm._v(" "), _c('div', {
    staticClass: "sbs-pm-actions"
  }, [_c('button', {
    staticClass: "sbs-btn sbs-btn-primary sbs-btn-with-icon",
    attrs: {
      "type": "button",
      "disabled": _vm.updatePaymentInProgress
    },
    on: {
      "click": _vm.openPrimaryPaymentUpdate
    }
  }, [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 20 20",
      "fill": "currentColor",
      "aria-hidden": "true"
    }
  }, [_c('path', {
    attrs: {
      "d": "M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zm-2.207 2.207L3 14v3h3l8.379-8.379-2.828-2.828z"
    }
  })]), _vm._v("\n            " + _vm._s(_vm.primaryPaymentButtonLabel) + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "sbs-btn sbs-btn-outline sbs-btn-with-icon sbs-pm-add-wrap",
    attrs: {
      "id": "sbsPaymentMethodsAdd"
    }
  }, [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 20 20",
      "fill": "currentColor",
      "aria-hidden": "true"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "d": "M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z",
      "clip-rule": "evenodd"
    }
  })]), _vm._v("\n            Add new method\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "ui fluid popup sbs-pay-popup",
    attrs: {
      "id": "sbsPayPopupAdd"
    }
  }, [_c('div', {
    staticClass: "ui two column center aligned very relaxed grid"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('h4', {
    staticClass: "ui header"
  }, [_vm._v("Card")]), _vm._v(" "), _c('button', {
    staticClass: "ui labeled icon button",
    class: {
      loading: _vm.stripeButtonClicked || _vm.updatePaymentInProgress,
      disabled: _vm.updatePaymentInProgress
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.openStripeWidgetFromAdd
    }
  }, [_c('i', {
    staticClass: "credit card alternative icon"
  }), _vm._v("Add card\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "ui top right attached teal label"
  }, [_vm._v("Recommended")])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h4', {
    staticClass: "ui header"
  }, [_vm._v("ACH transfer")]), _vm._v(" "), _c('div', {
    staticClass: "ui labeled icon button",
    class: {
      loading: _vm.updatePaymentInProgress,
      disabled: _vm.updatePaymentInProgress || _vm.achAlreadyOnFile
    },
    on: {
      "click": _vm.createAchFromAdd
    }
  }, [_c('i', {
    staticClass: "university icon"
  }), _vm._v("Set ACH\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "ui top right attached label"
  }, [_vm._v("Beta")])])]), _vm._v(" "), _c('div', {
    staticClass: "ui vertical divider"
  }, [_vm._v("OR")])])]), _vm._v(" "), _c('p', {
    staticClass: "sbs-billing-email-row"
  }, [_vm._v("\n          Billing email: "), _c('strong', [_vm._v(_vm._s(_vm.billingEmailDisplay))]), _vm._v(" "), _c('button', {
    staticClass: "sbs-link-inline",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.openBillingEmailModal
    }
  }, [_vm._v("Change")])]), _vm._v(" "), (_vm.billingVariant === 'new' && _vm.showNextBillLine) ? _c('p', {
    staticClass: "sbs-next-bill"
  }, [_vm._v("Based on the current number of ASINs you are tracking, your next bill, charged to the payment method above, will be: "), _c('strong', [_vm._v("$" + _vm._s(_vm.nextBillAmount))])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.showResumeSubscriptionBanner) ? _c('div', {
    staticClass: "sbs-resume-banner",
    attrs: {
      "role": "region",
      "aria-label": "Resume subscription"
    }
  }, [_c('div', {
    staticClass: "sbs-resume-banner-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('svg', {
    attrs: {
      "width": "20",
      "height": "20",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M8 5v14l11-7L8 5z",
      "fill": "currentColor"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "sbs-resume-banner-text"
  }, [_c('h3', {
    staticClass: "sbs-resume-banner-title"
  }, [_vm._v("Subscription ending soon")]), _vm._v(" "), _c('p', {
    staticClass: "sbs-resume-banner-desc"
  }, [_vm._v(_vm._s(_vm.resumeBannerDescription))])]), _vm._v(" "), _c('button', {
    staticClass: "sbs-resume-banner-btn",
    attrs: {
      "type": "button",
      "disabled": _vm.resumeInProgress
    },
    on: {
      "click": _vm.resumeSubscription
    }
  }, [_vm._v(_vm._s(_vm.resumeInProgress ? 'Resuming…' : 'Resume subscription'))])]) : (_vm.showCancelSubscriptionBanner) ? _c('div', {
    staticClass: "sbs-cancel-banner",
    attrs: {
      "role": "region",
      "aria-label": "Cancel subscription"
    }
  }, [_c('div', {
    staticClass: "sbs-cancel-banner-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('svg', {
    attrs: {
      "width": "20",
      "height": "20",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "9",
      "stroke": "currentColor",
      "stroke-width": "2"
    }
  }), _c('path', {
    attrs: {
      "d": "M12 7v6M12 16h.01",
      "stroke": "currentColor",
      "stroke-width": "2.2",
      "stroke-linecap": "round"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "sbs-cancel-banner-text"
  }, [_c('h3', {
    staticClass: "sbs-cancel-banner-title"
  }, [_vm._v("Cancel subscription")]), _vm._v(" "), _c('p', {
    staticClass: "sbs-cancel-banner-desc"
  }, [_vm._v(_vm._s(_vm.cancelBannerDescription))])]), _vm._v(" "), _c('button', {
    staticClass: "sbs-cancel-banner-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.openCancelWizard
    }
  }, [_vm._v("Cancel subscription")])]) : _vm._e(), _vm._v(" "), (_vm.message) ? _c('div', {
    staticClass: "sbs-flash sbs-flash-ok",
    attrs: {
      "role": "status"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.message))]), _vm._v(" "), _c('button', {
    staticClass: "sbs-flash-close",
    attrs: {
      "type": "button",
      "aria-label": "Dismiss"
    },
    on: {
      "click": function($event) {
        _vm.message = ''
      }
    }
  }, [_vm._v("×")])]) : _vm._e(), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "sbs-flash sbs-flash-err",
    attrs: {
      "role": "alert"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.error))]), _vm._v(" "), _c('button', {
    staticClass: "sbs-flash-close",
    attrs: {
      "type": "button",
      "aria-label": "Dismiss"
    },
    on: {
      "click": function($event) {
        _vm.error = ''
      }
    }
  }, [_vm._v("×")])]) : _vm._e()], 2), _vm._v(" "), (_vm.showUsageTab) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab === 'usage'),
      expression: "activeTab === 'usage'"
    }],
    staticClass: "sbs-panel"
  }, [(_vm.usageTabLoading) ? _c('div', {
    staticClass: "sbs-usage-loading"
  }, [_c('div', {
    staticClass: "sbs-spinner"
  })]) : (_vm.usageTabError) ? _c('div', {
    staticClass: "sbs-usage-error"
  }, [_c('p', {
    staticClass: "sbs-error-msg"
  }, [_vm._v(_vm._s(_vm.usageTabError))]), _vm._v(" "), _c('button', {
    staticClass: "sbs-btn sbs-btn-outline",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.loadUsageTabData
    }
  }, [_vm._v("Retry")])]) : [_c('h2', {
    staticClass: "sbs-usage-title"
  }, [_vm._v("Usage")]), _vm._v(" "), _c('p', {
    staticClass: "sbs-usage-subtitle"
  }, [_vm._v(_vm._s(_vm.usageBillingPeriodLine))]), _vm._v(" "), _c('div', {
    staticClass: "sbs-ucards"
  }, [_c('div', {
    staticClass: "sbs-ucard"
  }, [_c('div', {
    staticClass: "sbs-uc-lbl"
  }, [_vm._v("Current plan")]), _vm._v(" "), _c('div', {
    staticClass: "sbs-uc-val"
  }, [_vm._v(_vm._s(_vm.usageCurrentPlanName))]), _vm._v(" "), _c('div', {
    staticClass: "sbs-uc-sub"
  }, [_vm._v(_vm._s(_vm.usagePlanPriceSubline))])]), _vm._v(" "), _c('div', {
    staticClass: "sbs-ucard sbs-ucard-lever"
  }, [_c('div', {
    staticClass: "sbs-uc-lbl"
  }, [_vm._v("Storefronts connected")]), _vm._v(" "), _c('div', {
    staticClass: "sbs-uc-val"
  }, [_vm._v(_vm._s(_vm.usageStorefrontsCountDisplay))]), _vm._v(" "), _c('div', {
    staticClass: "sbs-uc-sub"
  }, [_vm._v("The only thing that affects your price")])]), _vm._v(" "), _c('div', {
    staticClass: "sbs-ucard"
  }, [_c('div', {
    staticClass: "sbs-uc-lbl"
  }, [_vm._v("Next charge")]), _vm._v(" "), _c('div', {
    staticClass: "sbs-uc-val"
  }, [_vm._v(_vm._s(_vm.usageNextChargeShortDisplay))]), _vm._v(" "), _c('div', {
    staticClass: "sbs-uc-sub"
  }, [_vm._v(_vm._s(_vm.usageNextChargeSubline))])])]), _vm._v(" "), _c('div', {
    staticClass: "sbs-ublock"
  }, [_c('h3', {
    staticClass: "sbs-ublock-title"
  }, [_vm._v("What we're monitoring for you")]), _vm._v(" "), _c('div', {
    staticClass: "sbs-ucards sbs-ucards-inner"
  }, [_c('div', {
    staticClass: "sbs-ucard sbs-ucard-muted"
  }, [_c('div', {
    staticClass: "sbs-uc-lbl"
  }, [_vm._v("ASINs monitored")]), _vm._v(" "), _c('div', {
    staticClass: "sbs-uc-val"
  }, [_vm._v(_vm._s(_vm.usageAsinsMonitoredDisplay))]), _vm._v(" "), _c('div', {
    staticClass: "sbs-uc-sub"
  }, [_vm._v("Unlimited on your plan")])]), _vm._v(" "), _c('div', {
    staticClass: "sbs-ucard sbs-ucard-muted"
  }, [_c('div', {
    staticClass: "sbs-uc-lbl"
  }, [_vm._v("Marketplaces covered")]), _vm._v(" "), _c('div', {
    staticClass: "sbs-uc-val"
  }, [_vm._v(_vm._s(_vm.usageMarketplacesCountDisplay))]), _vm._v(" "), _c('div', {
    staticClass: "sbs-uc-sub"
  }, [_vm._v("Unlimited on your plan")])])])]), _vm._v(" "), _c('div', {
    staticClass: "sbs-ublock"
  }, [_c('h3', {
    staticClass: "sbs-ublock-title"
  }, [_vm._v("What we caught this period")]), _vm._v(" "), (!_vm.usageCategoriesWithBars.length) ? _c('div', {
    staticClass: "sbs-usage-empty"
  }, [_vm._v("No changes recorded this period.")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.usageCategoriesWithBars), function(row) {
    return _c('div', {
      key: row.key || row.label,
      staticClass: "sbs-usage-bar"
    }, [_c('span', {
      staticClass: "sbs-usage-bar-name"
    }, [_vm._v(_vm._s(row.label))]), _vm._v(" "), _c('span', {
      staticClass: "sbs-usage-bar-track"
    }, [_c('span', {
      staticClass: "sbs-usage-bar-fill",
      style: ({
        width: row.barWidth
      })
    })]), _vm._v(" "), _c('span', {
      staticClass: "sbs-usage-bar-num"
    }, [_vm._v(_vm._s(row.countDisplay))])])
  })], 2)]], 2) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab === 'history'),
      expression: "activeTab === 'history'"
    }],
    staticClass: "sbs-panel"
  }, [_c('div', {
    staticClass: "sbs-history-card"
  }, [_c('div', {
    staticClass: "sbs-history-head"
  }, [_c('h2', {
    staticClass: "sbs-history-title"
  }, [_vm._v("Billing History")]), _vm._v(" "), (_vm.invoices.length) ? _c('button', {
    staticClass: "sbs-link-download",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.downloadAllInvoices
    }
  }, [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 20 20",
      "fill": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "d": "M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z",
      "clip-rule": "evenodd"
    }
  })]), _vm._v("\n            Download all\n          ")]) : _vm._e()]), _vm._v(" "), (!_vm.invoices.length) ? _c('div', {
    staticClass: "sbs-empty-invoices"
  }, [_vm._v("You have no invoices yet.")]) : _c('div', {
    staticClass: "sbs-history-table-wrap"
  }, [_c('table', {
    staticClass: "sbs-history-table"
  }, [_vm._m(18), _vm._v(" "), _c('tbody', _vm._l((_vm.invoices), function(inv, idx) {
    return _c('tr', {
      key: idx
    }, [_c('td', [_vm._v(_vm._s(_vm.formatInvoiceDate(_vm.invoicePaidOn(inv))))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.invoiceDescription(inv, idx)))]), _vm._v(" "), _c('td', {
      staticClass: "sbs-col-amt"
    }, [_c('strong', [_vm._v("$" + _vm._s((inv.totalAmount / 100).toFixed(2)))])]), _vm._v(" "), _vm._m(19, true), _vm._v(" "), _c('td', [(inv.url) ? _c('a', {
      staticClass: "sbs-receipt-link",
      attrs: {
        "href": inv.url,
        "target": "_blank",
        "rel": "noopener noreferrer"
      }
    }, [_vm._v("Receipt")]) : _vm._e()])])
  }), 0)])])])])]), _vm._v(" "), (_vm.cancelModalVisible) ? _c('div', {
    staticClass: "sbs-cancel-overlay",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.closeCancelWizardIfIdle.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "sbs-cancel-sheet",
    attrs: {
      "role": "dialog",
      "aria-modal": "true",
      "aria-labelledby": "sbs-cancel-title"
    }
  }, [_c('button', {
    staticClass: "sbs-cancel-close",
    attrs: {
      "type": "button",
      "disabled": _vm.cancelFlowSubmitting,
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeCancelWizardIfIdle
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('div', {
    staticClass: "sbs-cancel-progress",
    attrs: {
      "aria-hidden": "true"
    }
  }, _vm._l((4), function(n) {
    return _c('span', {
      key: n,
      class: ['sbs-cancel-progress-seg', _vm.cancelProgressSegClass(n)]
    })
  }), 0), _vm._v(" "), _c('header', {
    staticClass: "sbs-cancel-header"
  }, [_c('h2', {
    staticClass: "sbs-cancel-heading",
    attrs: {
      "id": "sbs-cancel-title"
    }
  }, [_vm._v("Are you sure you want to cancel?")]), _vm._v(" "), _c('p', {
    staticClass: "sbs-cancel-subtitle"
  }, [_vm._v("\n          Your subscription will remain active until "), _c('strong', [_vm._v(_vm._s(_vm.cancelModalPeriodEndDisplay))]), _vm._v(".\n          You can resume anytime before then.\n        ")])]), _vm._v(" "), (_vm.cancelPreviewError && _vm.cancelModalStep === 1) ? _c('p', {
    staticClass: "sbs-cancel-alert"
  }, [_vm._v(_vm._s(_vm.cancelPreviewError))]) : _vm._e(), _vm._v(" "), (_vm.cancelModalStep === 1) ? _c('div', {
    staticClass: "sbs-cancel-body"
  }, [(_vm.cancelPreview && _vm.cancelPreview.alreadyScheduledForCancel) ? _c('p', {
    staticClass: "sbs-cancel-impact-plain"
  }, [_vm._v("\n          Cancellation is scheduled for the end of "), _c('strong', [_vm._v(_vm._s(_vm.cancelPreview.periodEndFormatted))]), _vm._v(".\n          You still have access until then. Click "), _c('strong', [_vm._v("Resume subscription")]), _vm._v(" below to keep your plan active and billing on schedule.\n        ")]) : (_vm.cancelPreviewLoading) ? _c('p', {
    staticClass: "sbs-cancel-impact-plain"
  }, [_vm._v("Loading your billing timeline…")]) : (_vm.cancelPreview) ? _c('div', {
    staticClass: "sbs-cancel-impact-box"
  }, [_c('p', {
    staticClass: "sbs-cancel-impact-row sbs-cancel-impact-row--ok"
  }, [_c('span', {
    staticClass: "sbs-cancel-impact-icon sbs-cancel-impact-icon--ok",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("✓")]), _vm._v(" "), _c('span', [_vm._v("You'll keep full access until "), _c('strong', [_vm._v(_vm._s(_vm.cancelPreview.periodEndFormatted))]), _vm._v(". No prorated refund — you've already paid for this period.")])]), _vm._v(" "), _vm._m(20), _vm._v(" "), _c('p', {
    staticClass: "sbs-cancel-impact-row"
  }, [_c('span', {
    staticClass: "sbs-cancel-impact-icon sbs-cancel-impact-icon--warn",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("⏱")]), _vm._v(" "), _c('span', [_vm._v("Your "), _c('strong', [_vm._v("30-day alert history, COGS data, and competitor profiles")]), _vm._v(" stay in your account for " + _vm._s(_vm.cancelPreview.dataRetentionDays || 90) + " days in case you come back.")])]), _vm._v(" "), (_vm.cancelPreview.showLegacyMigrationWarning) ? _c('p', {
    staticClass: "sbs-cancel-warn-legacy sbs-cancel-warn-legacy--in-box"
  }, [_vm._v("\n            You migrated from our legacy billing platform — double-check exporting anything you rely on before access changes.\n          ")]) : _vm._e(), _vm._v(" "), (_vm.cancelPreview.stripeWillCancelImmediately) ? _c('p', {
    staticClass: "sbs-cancel-warn sbs-cancel-warn--in-box"
  }, [_vm._v("\n            We could not detect a reusable card or bank mandate on file, so cancelling will stop your subscription immediately.\n          ")]) : _vm._e()]) : _vm._e()]) : (_vm.cancelModalStep === 2) ? [_c('div', {
    staticClass: "sbs-cancel-body"
  }, [_c('div', {
    staticClass: "sbs-cancel-save-offer"
  }, [_c('h3', {
    staticClass: "sbs-cancel-save-offer-title"
  }, [_vm._v("Wait — would a customized plan keep you here?")]), _vm._v(" "), _c('p', {
    staticClass: "sbs-cancel-save-offer-text"
  }, [_vm._v("\n              If pricing, capacity, or alert volume is the issue, we can build a plan around your specific setup — different ASIN cap, alert filtering, or a discounted rate. No pressure: it's just a 5-min email.\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "sbs-cancel-save-offer-yes",
    attrs: {
      "type": "button",
      "disabled": _vm.cancelFlowSubmitting
    },
    on: {
      "click": _vm.onCancelSaveOfferYes
    }
  }, [_vm._v("\n              Yes, talk to me about a custom plan\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "sbs-cancel-save-offer-no",
    attrs: {
      "type": "button",
      "disabled": _vm.cancelFlowSubmitting
    },
    on: {
      "click": _vm.onCancelSaveOfferNo
    }
  }, [_vm._v("\n              No thanks, continue cancelling\n            ")]), _vm._v(" "), (_vm.cancelFlowError) ? _c('p', {
    staticClass: "sbs-cancel-alert"
  }, [_vm._v(_vm._s(_vm.cancelFlowError))]) : _vm._e()])])] : (_vm.cancelModalStep === 3) ? [_c('div', {
    staticClass: "sbs-cancel-body sbs-cancel-body--survey"
  }, [_vm._m(21), _vm._v(" "), _c('div', {
    staticClass: "sbs-cancel-reason-list",
    attrs: {
      "role": "radiogroup",
      "aria-labelledby": "sbs-cancel-reason-heading"
    }
  }, _vm._l((_vm.cancelReasonOptions), function(opt) {
    return _c('label', {
      key: opt.id,
      class: ['sbs-cancel-reason-card', {
        'sbs-cancel-reason-card--selected': _vm.cancelSurveyReason === opt.id
      }]
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.cancelSurveyReason),
        expression: "cancelSurveyReason"
      }],
      staticClass: "sbs-cancel-reason-input",
      attrs: {
        "type": "radio"
      },
      domProps: {
        "value": opt.id,
        "checked": _vm._q(_vm.cancelSurveyReason, opt.id)
      },
      on: {
        "change": function($event) {
          _vm.cancelSurveyReason = opt.id
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "sbs-cancel-reason-copy"
    }, [_c('span', {
      staticClass: "sbs-cancel-reason-title"
    }, [_vm._v(_vm._s(opt.label))]), _vm._v(" "), _c('span', {
      staticClass: "sbs-cancel-reason-sub"
    }, [_vm._v(_vm._s(opt.subtitle))])])])
  }), 0), _vm._v(" "), (_vm.cancelSurveyReason === 'too_many_alerts') ? _c('div', {
    staticClass: "sbs-cancel-pills-block",
    attrs: {
      "id": "condAlerts"
    }
  }, [_c('p', {
    staticClass: "sbs-cancel-pills-heading"
  }, [_vm._v("Which alert types? (select all that apply)")]), _vm._v(" "), _c('div', {
    staticClass: "sbs-cancel-pills-wrap"
  }, _vm._l((_vm.cancelAlertTagOptions), function(tag) {
    return _c('label', {
      key: tag.id,
      class: ['sbs-cancel-pill', {
        'sbs-cancel-pill--on': _vm.cancelSurveyAlertTags.indexOf(tag.id) !== -1
      }]
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.cancelSurveyAlertTags),
        expression: "cancelSurveyAlertTags"
      }],
      staticClass: "sbs-cancel-pill-input",
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": tag.id,
        "checked": Array.isArray(_vm.cancelSurveyAlertTags) ? _vm._i(_vm.cancelSurveyAlertTags, tag.id) > -1 : (_vm.cancelSurveyAlertTags)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.cancelSurveyAlertTags,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = tag.id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.cancelSurveyAlertTags = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.cancelSurveyAlertTags = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.cancelSurveyAlertTags = $$c
          }
        }
      }
    }), _vm._v("\n                " + _vm._s(tag.label) + "\n              ")])
  }), 0), _vm._v(" "), _c('p', {
    staticClass: "sbs-cancel-pills-hint"
  }, [_vm._v("Helps us tune alert relevance for everyone.")])]) : _vm._e(), _vm._v(" "), (_vm.cancelSurveyReason === 'found_alternative') ? _c('div', {
    staticClass: "sbs-cancel-survey-section",
    attrs: {
      "id": "condCompetitor"
    }
  }, [_c('label', {
    staticClass: "sbs-cancel-field-label",
    attrs: {
      "for": "sbs-cancel-comp"
    }
  }, [_vm._v("Which tool are you switching to?")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cancelSurveyCompetitor),
      expression: "cancelSurveyCompetitor"
    }],
    staticClass: "sbs-cancel-select",
    attrs: {
      "id": "sbs-cancel-comp"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.cancelSurveyCompetitor = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select…")]), _vm._v(" "), _vm._l((_vm.competitorOptions), function(c) {
    return _c('option', {
      key: c,
      domProps: {
        "value": c
      }
    }, [_vm._v(_vm._s(c))])
  })], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "sbs-cancel-survey-section"
  }, [_c('label', {
    staticClass: "sbs-cancel-field-label"
  }, [_vm._v("Is there anything we can do to make you stay?")]), _vm._v(" "), _c('div', {
    staticClass: "sbs-cancel-segment",
    attrs: {
      "role": "group",
      "aria-label": "Would you stay"
    }
  }, [_c('button', {
    class: ['sbs-cancel-segment-btn', {
      'sbs-cancel-segment-btn--active': _vm.cancelStayAnswer === 'yes'
    }],
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.cancelStayAnswer = 'yes'
      }
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('button', {
    class: ['sbs-cancel-segment-btn', {
      'sbs-cancel-segment-btn--active': _vm.cancelStayAnswer === 'no'
    }],
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.cancelStayAnswer = 'no'
      }
    }
  }, [_vm._v("No")])])]), _vm._v(" "), _c('div', {
    staticClass: "sbs-cancel-survey-section"
  }, [_vm._m(22), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cancelDetailText),
      expression: "cancelDetailText"
    }],
    staticClass: "sbs-cancel-textarea",
    attrs: {
      "id": "sbs-cancel-detail",
      "rows": "4",
      "maxlength": "7500",
      "placeholder": "What could we have done better? What feature would have changed your mind?"
    },
    domProps: {
      "value": (_vm.cancelDetailText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cancelDetailText = $event.target.value
      }
    }
  })])])] : (_vm.cancelModalStep === 4) ? [_c('div', {
    staticClass: "sbs-cancel-body"
  }, [_c('div', {
    staticClass: "sbs-cancel-final-box"
  }, [_c('p', {
    staticClass: "sbs-cancel-final-box-text"
  }, [_c('span', {
    staticClass: "sbs-cancel-final-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("!")]), _vm._v(" "), _c('strong', [_vm._v("Final step.")]), _vm._v("\n              When you click \"Confirm cancellation\" below, your subscription will be set to cancel on\n              "), _c('strong', [_vm._v(_vm._s(_vm.cancelModalPeriodEndDisplay))]), _vm._v(". You can resume anytime before that date with one click.\n            ")])]), _vm._v(" "), _c('p', {
    staticClass: "sbs-cancel-final-copy"
  }, [_vm._v("\n            After this, you'll get a confirmation email from us and your access will continue exactly as today until the end of the period. We'll be sad to see you go.\n          ")]), _vm._v(" "), (_vm.cancelFlowError) ? _c('p', {
    staticClass: "sbs-cancel-alert"
  }, [_vm._v(_vm._s(_vm.cancelFlowError))]) : _vm._e()])] : _vm._e(), _vm._v(" "), _c('footer', {
    staticClass: "sbs-cancel-footer"
  }, [_c('button', {
    staticClass: "sbs-cancel-footer-keep",
    attrs: {
      "type": "button",
      "disabled": _vm.cancelFlowSubmitting || _vm.resumeInProgress
    },
    on: {
      "click": _vm.onCancelFooterKeep
    }
  }, [_vm._v(_vm._s(_vm.cancelFooterKeepLabel))]), _vm._v(" "), _c('button', {
    staticClass: "sbs-cancel-footer-continue",
    attrs: {
      "type": "button",
      "disabled": _vm.cancelFooterContinueDisabled
    },
    on: {
      "click": _vm.onCancelFooterContinue
    }
  }, [_vm._v(_vm._s(_vm.cancelFooterContinueLabel))])])], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ui small modal",
    attrs: {
      "id": "sbsPaymentElementModal"
    }
  }, [_c('i', {
    staticClass: "close icon",
    on: {
      "click": _vm.unmountPaymentElement
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "header"
  }, [_vm._v(_vm._s(_vm.paymentModalTitle))]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [(_vm.error) ? _c('div', {
    staticClass: "ui error message"
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "id": "sbs-payment-element"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "sbs-payment-element-errors",
      "role": "alert"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('div', {
    staticClass: "ui black deny button"
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('div', {
    staticClass: "ui positive right labeled icon button",
    class: {
      loading: _vm.updatePaymentInProgress,
      disabled: _vm.updatePaymentInProgress
    },
    on: {
      "click": _vm.confirmPaymentMethod
    }
  }, [_vm._v("\n        Save"), _c('i', {
    staticClass: "checkmark icon"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "ui small modal",
    attrs: {
      "id": "sbsPlanChangeModal"
    }
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("Plan changes")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('p', {
    staticClass: "sbs-modal-copy"
  }, [_vm._v("To change your subscription or discuss billing options, email our team.")]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "ui primary button",
    attrs: {
      "href": _vm.planChangeMailHref
    }
  }, [_vm._v("Email support@sentrykit.com →")])])]), _vm._v(" "), _vm._m(23)]), _vm._v(" "), _c('div', {
    staticClass: "ui small modal",
    attrs: {
      "id": "sbsBillingEmailModal"
    }
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("Billing email")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('p', {
    staticClass: "sbs-modal-copy"
  }, [_vm._v("Receipts and billing notices are sent to "), _c('strong', [_vm._v(_vm._s(_vm.billingEmailDisplay))]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "sbs-modal-copy"
  }, [_vm._v("To update the email on file with Stripe, contact support and we'll take care of it.")]), _vm._v(" "), _vm._m(24)]), _vm._v(" "), _vm._m(25)]), _vm._v(" "), _c('div', {
    staticClass: "ui tiny modal",
    attrs: {
      "id": "sbsAchDetailsModal"
    }
  }, [_c('i', {
    staticClass: "close icon"
  }), _vm._v(" "), (_vm.paymentMethod) ? [_c('div', {
    staticClass: "header"
  }, [_vm._v("ACH details")]), _vm._v(" "), (_vm.paymentMethod.details) ? _c('div', {
    staticClass: "content",
    staticStyle: {
      "padding-bottom": "2em"
    }
  }, [_c('div', {
    staticClass: "ui relaxed divided list"
  }, _vm._l((_vm.paymentMethod.details), function(value, name) {
    return _c('div', {
      key: name,
      staticClass: "item"
    }, [_c('div', {
      staticClass: "header",
      staticStyle: {
        "text-transform": "capitalize"
      }
    }, [_vm._v(_vm._s(String(name).replace(/_/g, ' ')))]), _vm._v(" "), _c('div', {
      staticClass: "description"
    }, [_vm._v(_vm._s(name === 'balance' ? (value / 100).toFixed(2) + ' USD' : value))])])
  }), 0)]) : _vm._e()] : _vm._e(), _vm._v(" "), _vm._m(26)], 2), _vm._v(" "), (_vm.upgradeModalOpen) ? _c('div', {
    staticClass: "sbs-min-modal-backdrop",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.closeUpgradeModal.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "sbs-min-modal",
    attrs: {
      "role": "dialog",
      "aria-modal": "true",
      "aria-labelledby": "sbs-upg-title",
      "tabindex": "-1"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [(_vm.upgradeModalPhase === 'no_payment') ? [_c('h3', {
    staticClass: "sbs-min-modal-title",
    attrs: {
      "id": "sbs-upg-title"
    }
  }, [_vm._v("Add a card to choose " + _vm._s(_vm.upgradeModalPlanName))]), _vm._v(" "), _c('p', {
    staticClass: "sbs-min-modal-body"
  }, [_vm._v("\n          " + _vm._s(_vm.upgradeModalPlanName) + " is "), _c('strong', [_vm._v(_vm._s(_vm.upgradeModalPriceLabel))]), _vm._v(".\n          " + _vm._s(_vm.upgradeModalNoPaymentTail) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "sbs-min-modal-actions"
  }, [_c('button', {
    staticClass: "sbs-min-modal-btn sbs-min-modal-btn-secondary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closeUpgradeModal
    }
  }, [_vm._v("Not now")]), _vm._v(" "), _c('button', {
    staticClass: "sbs-min-modal-btn sbs-min-modal-btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.onUpgradeModalAddPayment
    }
  }, [_vm._v("Add card")])])] : [_c('h3', {
    staticClass: "sbs-min-modal-title",
    attrs: {
      "id": "sbs-upg-title"
    }
  }, [_vm._v(_vm._s(_vm.upgradeModalTitle))]), _vm._v(" "), _c('dl', {
    staticClass: "sbs-min-modal-summary"
  }, [_c('div', [_c('dt', [_vm._v("New plan")]), _c('dd', [_vm._v(_vm._s(_vm.upgradeModalPlanName) + " · " + _vm._s(_vm.upgradeModalPriceLabel))])]), _vm._v(" "), _c('div', [_c('dt', [_vm._v("Charged today")]), _c('dd', [_vm._v(_vm._s(_vm.upgradeModalChargeToday))])]), _vm._v(" "), _c('div', [_c('dt', [_vm._v(_vm._s(_vm.upgradeModalRenewLabel))]), _c('dd', [_vm._v(_vm._s(_vm.upgradeModalRenewValue))])])]), _vm._v(" "), (_vm.upgradeModalNote) ? _c('p', {
    staticClass: "sbs-min-modal-body sbs-min-modal-note"
  }, [_vm._v(_vm._s(_vm.upgradeModalNote))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "sbs-min-modal-actions"
  }, [_c('button', {
    staticClass: "sbs-min-modal-btn sbs-min-modal-btn-secondary",
    attrs: {
      "type": "button",
      "disabled": _vm.upgradeInProgress
    },
    on: {
      "click": _vm.closeUpgradeModal
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "sbs-min-modal-btn sbs-min-modal-btn-primary",
    attrs: {
      "type": "button",
      "disabled": _vm.upgradeInProgress
    },
    on: {
      "click": _vm.confirmUpgradeModal
    }
  }, [_vm._v("\n            " + _vm._s(_vm.upgradeInProgress ? 'Switching…' : _vm.upgradeModalConfirmLabel) + "\n          ")])])]], 2)]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    staticClass: "sbs-trial-badge sbs-trial-badge-expired"
  }, [_vm._v("Payment failed")]), _vm._v(" "), _c('div', {
    staticClass: "sbs-trial-title"
  }, [_vm._v("Your last payment didn't go through")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    staticClass: "sbs-trial-badge sbs-trial-badge-expired"
  }, [_vm._v("Trial Ended")]), _vm._v(" "), _c('div', {
    staticClass: "sbs-trial-title"
  }, [_vm._v("Your free trial has ended")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sbs-trial-days"
  }, [_c('div', {
    staticClass: "sbs-trial-days-num"
  }, [_vm._v("0")]), _vm._v(" "), _c('div', {
    staticClass: "sbs-trial-days-lbl"
  }, [_vm._v("Days remaining")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sbs-trial-progress"
  }, [_c('div', {
    staticClass: "sbs-trial-progress-fill",
    staticStyle: {
      "width": "100%"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "sbs-trial-badge"
  }, [_c('span', {
    staticClass: "sbs-trial-pulse-dot"
  }), _vm._v("Trial Active")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "sbs-plan-price"
  }, [_c('span', {
    staticClass: "sbs-plan-currency"
  }, [_vm._v("$")]), _c('span', {
    staticClass: "sbs-plan-amount"
  }, [_vm._v("19")]), _c('span', {
    staticClass: "sbs-plan-period"
  }, [_vm._v("/month")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "sbs-plan-features"
  }, [_c('li', [_vm._v("Unlimited ASINs & all marketplaces")]), _vm._v(" "), _c('li', [_vm._v("2 storefronts included")]), _vm._v(" "), _c('li', [_vm._v("All alert types · real-time delivery")]), _vm._v(" "), _c('li', [_vm._v("COGS, floor price & margin alerts")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "sbs-plan-price"
  }, [_c('span', {
    staticClass: "sbs-plan-currency"
  }, [_vm._v("$")]), _c('span', {
    staticClass: "sbs-plan-amount"
  }, [_vm._v("49")]), _c('span', {
    staticClass: "sbs-plan-period"
  }, [_vm._v("/month")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "sbs-plan-features sbs-plan-features-pro"
  }, [_c('li', [_vm._v("Competitor seller profiles")]), _vm._v(" "), _c('li', [_vm._v("Seller name, location & storefront")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("AI Mode")]), _vm._v(" "), _c('span', {
    staticClass: "sbs-phase-pill"
  }, [_vm._v("Phase 2")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Storefronts")]), _c('th', [_vm._v("Per storefront")]), _c('th', [_vm._v("Volume saving")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tbody', [_c('tr', [_c('td', [_vm._v("1–5")]), _c('td', [_vm._v("Included in $49")]), _c('td', [_vm._v("—")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("6–15")]), _c('td', [_vm._v("$19")]), _c('td', [_vm._v("—")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("16–30")]), _c('td', [_vm._v("$14")]), _c('td', {
    staticClass: "sbs-sf-saving"
  }, [_vm._v("~26% lower")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("31–60")]), _c('td', [_vm._v("$10")]), _c('td', {
    staticClass: "sbs-sf-saving"
  }, [_vm._v("~47% lower")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("61+")]), _c('td', [_vm._v("$7")]), _c('td', {
    staticClass: "sbs-sf-saving"
  }, [_vm._v("~63% lower")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "sbs-plan-features sbs-plan-features-pro"
  }, [_c('li', [_vm._v("One payment covers the whole year")]), _vm._v(" "), _c('li', [_vm._v("No monthly card charges to track")]), _vm._v(" "), _c('li', [_vm._v("Extra storefronts billed yearly at the Pro rates")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    staticClass: "sbs-trial-badge sbs-trial-badge-expired"
  }, [_vm._v("Trial Ended")]), _vm._v(" "), _c('div', {
    staticClass: "sbs-trial-title"
  }, [_vm._v("Your free trial has ended")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sbs-trial-days"
  }, [_c('div', {
    staticClass: "sbs-trial-days-num"
  }, [_vm._v("0")]), _vm._v(" "), _c('div', {
    staticClass: "sbs-trial-days-lbl"
  }, [_vm._v("Days remaining")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sbs-trial-progress"
  }, [_c('div', {
    staticClass: "sbs-trial-progress-fill",
    staticStyle: {
      "width": "100%"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sbs-enterprise-bar"
  }, [_c('div', {
    staticClass: "sbs-enterprise-bar-text"
  }, [_c('strong', [_vm._v("Agency / Enterprise")]), _vm._v(" "), _c('span', [_vm._v("For white-label, invoicing, SLAs or volume terms · custom pricing from ~$199/mo")])]), _vm._v(" "), _c('a', {
    staticClass: "sbs-enterprise-bar-btn",
    attrs: {
      "href": "mailto:support@sentrykit.com"
    }
  }, [_vm._v("Talk to us →")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sbs-pm-display-actions"
  }, [_c('span', {
    staticClass: "sbs-pm-default-badge"
  }, [_vm._v("Default")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sbs-pm-display-main"
  }, [_c('div', {
    staticClass: "sbs-pm-display-top"
  }, [_c('span', {
    staticClass: "sbs-pm-display-title"
  }, [_vm._v("Bank transfer (ACH)")]), _vm._v(" "), _c('div', {
    staticClass: "sbs-pm-display-actions"
  }, [_c('span', {
    staticClass: "sbs-pm-default-badge"
  }, [_vm._v("Default")])])]), _vm._v(" "), _c('span', {
    staticClass: "sbs-pm-display-meta"
  }, [_vm._v("Tap “View bank details” for account info.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Date")]), _vm._v(" "), _c('th', [_vm._v("Description")]), _vm._v(" "), _c('th', {
    staticClass: "sbs-col-amt"
  }, [_vm._v("Amount")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('span', {
    staticClass: "sbs-status-paid"
  }, [_c('span', {
    staticClass: "sbs-status-dot"
  }), _vm._v("Paid")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "sbs-cancel-impact-row"
  }, [_c('span', {
    staticClass: "sbs-cancel-impact-icon sbs-cancel-impact-icon--warn",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("⏱")]), _vm._v(" "), _c('span', [_vm._v("After that date, all "), _c('strong', [_vm._v("real-time alerts")]), _vm._v(" stop. Buy Box monitoring, hijacker detection, suppression alerts — all paused.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "sbs-cancel-field-label",
    attrs: {
      "id": "sbs-cancel-reason-heading"
    }
  }, [_vm._v("Why are you cancelling? "), _c('span', {
    staticClass: "sbs-cancel-req"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "sbs-cancel-field-label",
    attrs: {
      "for": "sbs-cancel-detail"
    }
  }, [_vm._v("\n              Anything else you want us to know? "), _c('span', {
    staticClass: "sbs-cancel-opt"
  }, [_vm._v("(optional)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "actions"
  }, [_c('div', {
    staticClass: "ui approve button"
  }, [_vm._v("Close")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    staticClass: "ui primary button",
    attrs: {
      "href": "mailto:support@sentrykit.com?subject=SentryKit%20billing%20email%20change"
    }
  }, [_vm._v("Contact support →")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "actions"
  }, [_c('div', {
    staticClass: "ui approve button"
  }, [_vm._v("Close")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "actions"
  }, [_c('div', {
    staticClass: "ui approve button"
  }, [_vm._v("Close")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7c0fe644!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/SubscriptionBillingSettings.vue
// module id = 795
// module chunks = 2